import _ from 'lodash';
import React from 'react';
import { Button, Row, Col } from 'reactstrap';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { querySpecification as querySpecificationHelper } from 'flaivy-react';

_.mixin(require('lodash-uuid'));

const getCategoryQuery = category => {
  if (_.get(category, 'query.or')) {
    return category.query;
  }
  return { or: [category.query] };
};
function CategoryTabs({ categories, onChange, querySpecification }) {
  const howActiveMap = categories.map(x => {
    const categoryQuery = getCategoryQuery(x);
    return (
      querySpecificationHelper.isSubsetOfQuerySpecification(
        querySpecification,
        categoryQuery,
      ) &&
      querySpecificationHelper.countQueryOverlap(
        querySpecification,
        categoryQuery,
      )
    );
  });

  const maxMatch = _.max(howActiveMap);
  const indexAtMax = _.findIndex(howActiveMap, x => maxMatch === x);
  return (
    <Row className="justify-content-center align-items-center mb-4">
      {categories.map((item, index) => (
        <Col xs="auto" key={_.uuid()}>
          <CategoryTab
            isActive={indexAtMax === index}
            key={item.id}
            onChange={onChange}
            category={item}
            querySpecification={querySpecification}
          />
        </Col>
      ))}
    </Row>
  );
}
CategoryTabs.propTypes = {
  categories: PropTypes.array,
  onChange: PropTypes.func.isRequired,
  querySpecification: PropTypes.object.isRequired,
};
CategoryTabs.defaultProps = {
  categories: [],
};
function CategoryTab({ category, onChange, isActive }) {
  const handleClick = () => {
    onChange(getCategoryQuery(category));
  };

  return (
    <Button
      onClick={handleClick}
      value={category.name}
      color="none"
      className={classnames({
        categoryTab: true,
        active: isActive,
      })}
    >
      {category.name}
    </Button>
  );
}

CategoryTab.propTypes = {
  category: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  isActive: PropTypes.bool.isRequired,
};

export default CategoryTabs;
